import React from "react";
import "../theme/Administracion.css";
import { AzureAD, AuthenticationState } from "react-aad-msal";
import { TableAdministracionComunicados } from "../components/TableAdministracionComunicados";
import { useDynamicAuth } from "../context/AuthProviderContext"; // Importar el hook
import { useNavigate } from "react-router-dom";
import { BtnGoBack } from "../components/Buttons/BtnGoBack";

export const AdminPageComunicados = () => {
  const navigate = useNavigate();
  const authProvider = useDynamicAuth(); // Usar el hook
  return (
    <AzureAD provider={authProvider}>
      {({ authenticationState, accountInfo }) => {
        const isAuthenticated = authenticationState === AuthenticationState.Authenticated;

        if (isAuthenticated) {
          return (
            <div className="body-color-admin">
              <div className="title-name-admin">
                <BtnGoBack caption="Volver a administración" />
              </div>

              <TableAdministracionComunicados />
            </div>
          );
        }
      }}
    </AzureAD>
  );
};
